import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslations } from 'next-intl';
import { connect } from 'react-redux';

import StyledLanguageSwitch from './languageSwitch.style';

const LanguageSwitch = ({ locale, inverted = false, ...props }) => {
  const t = useTranslations();
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => setIsVisible(true));
  if (!locale || (Array.isArray(locale) && locale.length <= 1)) return null;

  const { url, lang } = Array.isArray(locale) ? locale[0] : locale;

  return (
    <StyledLanguageSwitch inverted={inverted} {...props}>
      <a href={url} aria-label={t('languageSwitch.change')} alt={t('languageSwitch.change')}>
        {isVisible && lang}
        <span className="sr-only">{t('languageSwitch.change')}</span>
      </a>
    </StyledLanguageSwitch>
  );
};

LanguageSwitch.propTypes = {
  inverted: PropTypes.bool,
  locale: PropTypes.oneOf([PropTypes.shape(), PropTypes.arrayOf(PropTypes.shape())])
};

const mapStateToProps = state => ({
  locale: state.app.pageData.languageSwitch
});

export default connect(mapStateToProps)(LanguageSwitch);
